import { FC } from "react";

import { Box } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import { FullWidthVStack } from "@components/common";
import EmailInput from "@components/EmailInput";
import TextInput from "@components/TextInput";
import responsiveStyle from "@lib/theme/responsiveStyle";

import { ORDER_FIELDS_MAX_LENGTHS, OrderFields } from "../../../constants";

const InvoiceCompanyForm: FC = () => {
  const { t } = useTranslation();

  return (
    <FullWidthVStack
      maxWidth={responsiveStyle({ mobile: "100%", desktop: "22.25rem" })}
      ml={responsiveStyle({ mobile: "0", desktop: "13.125rem" })}
      mb="1rem"
      mt={responsiveStyle({ mobile: "1rem", desktop: "0" })}
    >
      <Box data-field={OrderFields.INVOICE_COMPANY_NAME}>
        <TextInput
          name={OrderFields.INVOICE_COMPANY_NAME}
          label={t("order-summary-invoice-company_name")}
          maxLength={ORDER_FIELDS_MAX_LENGTHS.default}
        />
      </Box>
      <Box data-field={OrderFields.INVOICE_REGISTRY_CODE}>
        <TextInput
          name={OrderFields.INVOICE_REGISTRY_CODE}
          label={t("order-summary-invoice-registry_code")}
          maxLength={ORDER_FIELDS_MAX_LENGTHS.default}
        />
      </Box>
      <Box data-field={OrderFields.INVOICE_COMPANY_EMAIL}>
        <EmailInput
          name={OrderFields.INVOICE_COMPANY_EMAIL}
          label={t("order-summary-invoice-email_address")}
          maxLength={ORDER_FIELDS_MAX_LENGTHS.default}
        />
      </Box>
      <Box data-field={OrderFields.INVOICE_VAT_NUMBER}>
        <TextInput
          name={OrderFields.INVOICE_VAT_NUMBER}
          label={`${t("order-summary-invoice-vat_number")} ${t("common-optional")}`}
          maxLength={ORDER_FIELDS_MAX_LENGTHS.default}
        />
      </Box>
      <Box data-field={OrderFields.INVOICE_REGISTRATION_ADDRESS}>
        <TextInput
          name={OrderFields.INVOICE_REGISTRATION_ADDRESS}
          label={t("order-summary-invoice-company_registration_address")}
          maxLength={ORDER_FIELDS_MAX_LENGTHS.default}
        />
      </Box>
    </FullWidthVStack>
  );
};
export default InvoiceCompanyForm;
